import { render, staticRenderFns } from "./PlanTooltip.vue?vue&type=template&id=fc944d46"
import script from "./PlanTooltip.vue?vue&type=script&lang=js"
export * from "./PlanTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports